/**
 * Constants for order form configuration
 */

export const SERVICE_TYPES = {
  INSTANT: "instant",
  NORMAL: "normal"
};

export const API_ENDPOINTS = {
  FAST_URL: process.env.REACT_APP_FAST_URL,
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
  YOUTUBE_API_KEY: process.env.REACT_APP_YOUTUBE_API_KEY
};

export const MIN_QUANTITY = 100;

export const SNACKBAR_POSITION = {
  vertical: "top",
  horizontal: "right"
};

export const FORM_STYLES = {
  minQuantityStyle: {
    color: "lightgrey",
    fontSize: "small",
  },
  minQuantityErrorStyle: {
    color: "red",
    fontSize: "small",
  }
};

export const SERVICE_TYPE_CONFIG = {
  [SERVICE_TYPES.INSTANT]: {
    label: "Instant Start",
    gradient: "linear-gradient(to bottom right, #267fbe, #73dff6)",
    description: "Orders are processed automatically and usually start within minutes"
  },
  [SERVICE_TYPES.NORMAL]: {
    label: "Manual Start",
    gradient: "linear-gradient(to bottom right, #2EB62C, #C5E8B7)",
    description: "Orders are processed by our team manually with a typical start time of 0-3 hours"
  }
};
